import type { AboutProps } from '../types'

/**
 * About page copy — keep in sync with `content/pages/about-us.md` (Tina / CMS source).
 * Kinetic page applies NODE_* labels in `about-us/page.tsx`.
 */
export const aboutUsContent: Omit<AboutProps, 'color'> = {
  heroTitle: 'PEOPLE, COMMUNITY, DELIVERY',
  heroDescription:
    'Cloud Shuttle is a founder-led data engineering consultancy in Australia and New Zealand. We organise meetups and DataEngBytes, and we help clients ship platforms, pipelines, and AI evaluation practice that lasts.',
  teamTitle: 'Meet our team',
  employees: [
    {
      name: 'Peter Hanssens',
      role: 'Founder and CEO',
      bio: "Founder and CEO of Cloud Shuttle. HQ at UOW Innovation Campus, North Wollongong (4.772 Google reviews). Regular Sydney base at Stone & Chalk Tech Central, Haymarket. I focus on open source and community-led work — organiser of data engineering meetups across Australia and New Zealand. Outside work I coach my son's soccer team.",
      email: 'peter@cloudshuttle.com.au',
      phone: '(+61) 433 825 293',
      image: '/uploads/team/peter-hanssens.jpg',
    },
    {
      name: 'Ganesh Tiwari',
      role: 'Data Engineer',
      bio: 'Data engineer with six years across consulting and client teams — reliable pipelines, platforms, and clear handover to the people who operate them. Long-distance runner outside of work.',
      email: 'info@cloudshuttle.com.au',
      phone: '(+61) 433 825 293',
      image: '/uploads/team/ganesh-tiwari.png',
    },
  ],
  valuesTitle: 'Our values',
  values: [
    {
      title: 'Community first',
      description:
        'We grow and support independent data engineering communities across Australia and New Zealand — meetups, workshops, and DataEngBytes — because practitioners deserve a vendor-neutral home before anyone sells them a platform.',
      icon: 'Users',
    },
    {
      title: 'Open, practical craft',
      description:
        'We favour open source and boring technology that teams can operate. Fancy architecture only earns its place when it survives handover, on-call, and your next hire.',
      icon: 'Zap',
    },
    {
      title: 'Outcomes you can defend',
      description:
        'We measure success by what runs in production: trustworthy pipelines, clear ownership, and AI evaluation you can explain to leadership — not slide decks that age in a week.',
      icon: 'Target',
    },
  ],
}

/** Kinetic HUD role suffixes — chrome only, not CMS prose. */
export const aboutUsKineticRoleLabels: Record<string, string> = {
  'Peter Hanssens': 'FOUNDER & CEO',
  'Ganesh Tiwari': 'DATA ENGINEER',
}
